// 脚本参数管理界面API
import utilits from '@/assets/utilits/request.js'
export default {
  namespaced: true,
  state: {},
  mutations: {

  },
  actions: {
    // cmpapi/getscriptconfig 3.9.2	获取脚本参数配置
    getscriptconfig ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/getscriptconfig', obj, callback)
    },
    // cmpapi/setscriptconfig 3.9.3	设置脚本参数
    setscriptconfig ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/setscriptconfig', obj, callback)
    },
    // cmpapi/delscriptconfig 3.10.4	删除脚本参数
    delscriptconfig ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/delscriptconfig', obj, callback)
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/scriptManage.js